module.exports = __webpack_public_path__ + "img/logo-m2g-long.e7b0ef59.png";